import { useState } from 'react';
import { register } from '../api/auth';
import { RegisterRequest } from '../types/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { encryptPassword } from '../utils/passwordEncryption';
import StorefrontLayout from '../components/StorefrontLayout';
import styles from '../styles/AuthPage.module.css';

export default function Register() {
  const [form, setForm] = useState<RegisterRequest>({ email: '', userName: '', password: '' });
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { setAccessToken } = useAuth();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });    
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const encryptedPassword = await encryptPassword(form.password ?? '');
      const response = await register({ ...form, password: encryptedPassword });
      if (response.data?.accessToken) setAccessToken(response.data.accessToken);
      navigate('/dashboard');
    } catch (err: any) {
      console.error('Registration submission failed:', {
        message: err instanceof Error ? err.message : 'Unknown error',
        status: err.response?.status,
        url: err.config?.url,
      });
      // Try to extract validation errors (ProblemDetails.errors)
      const data = err.response?.data;
      if (data?.errors && typeof data.errors === 'object') {
        const messages = Object.values(data.errors).flat().filter(Boolean) as string[];
        setError(messages.join('\n'));
      } else if (data?.title) {
        setError(data.title);
      } else {
        setError(err.response?.data?.message || 'Registration failed');
      }
    }
  };

 
return (
  <StorefrontLayout>
    <main className={styles.authMain}>
      <section className={styles.imagePanel} aria-label="Luma beauty story">
        <img src="https://images.unsplash.com/photo-1612817288484-6f916006741a?auto=format&fit=crop&w=1100&q=85" alt="Skincare products arranged on a sunny table" />
        <div className={styles.imageCopy}><span className={styles.imageKicker}>A little time for you</span><h1>Your skin,<br /><em>but better.</em></h1><p>Thoughtful essentials and small rituals, made personal.</p></div>
      </section>
      <section className={styles.formPanel}>
        <form onSubmit={handleSubmit} className={styles.formContainer}>
          <span className={styles.formKicker}>Join the ritual</span>
          <h2>Create account</h2>
          <p className={styles.formIntro}>Make your next beauty find feel like it was made for you.</p>
          <label className={styles.field}>Email address<input name="email" type="email" autoComplete="email" onChange={handleChange} required /></label>
          <label className={styles.field}>Username<input name="userName" type="text" autoComplete="username" onChange={handleChange} required /></label>
          <label className={styles.field}>Password<input name="password" type="password" autoComplete="new-password" onChange={handleChange} required /></label>
          <button type="submit" className={styles.submitButton}>Create your account</button>
          <button type="button" className={styles.switchButton} onClick={() => navigate('/login')}>Already have an account? <strong>Sign in</strong></button>
          {error && <p className={styles.error} role="alert">{error}</p>}
        </form>
      </section>
    </main>
  </StorefrontLayout>
);

}
